import './SkipContentButtons.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { getGlobalDictionaryTerm } from '../../utils';
const SkipContentButtons = () => {
  const [showbuttons, setShowbuttons] = useState(false);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const skipToContent = getGlobalDictionaryTerm(sitecoreContext, 'skipToContent') || "Skip to content";
  const skipToSearch = getGlobalDictionaryTerm(sitecoreContext, 'skipToSearch') || "Skip to search";
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const scrollContent = e => {
    e.preventDefault();
    const main = document.querySelector('.main');
    let mainHeight = 0;
    if (main) {
      mainHeight = main.offsetTop;
      main.setAttribute('tabindex', "-1");
      main.focus();
    }
    window.scrollTo(0, mainHeight);
  };
  const keyupTContent = e => {
    if (e.keyCode === 32) {
      e.stopPropagation();
      scrollContent(e);
    }
  };
  const clickSearch = e => {
    e.preventDefault();
    const search = document.querySelector('.search-box__link');
    if (search) {
      search.click();
    }
  };
  const keyupToSearch = e => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.stopPropagation();
      clickSearch(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "navigation",
    className: `${SkipContentButtonsStyles} ${rtl ? SkipContentButtonsStylesRtl : ''} `
  }, /*#__PURE__*/React.createElement("div", {
    className: `rs_skip skipContent ${showbuttons ? 'visible' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "skipContent__row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "skipContent__button",
    onKeyDown: e => {
      keyupTContent(e);
    },
    onClick: e => scrollContent(e),
    onFocus: () => setShowbuttons(true),
    onBlur: () => setShowbuttons(false)
  }, skipToContent), /*#__PURE__*/React.createElement("button", {
    className: "skipContent__button",
    onKeyDown: e => {
      keyupToSearch(e);
    },
    onClick: e => clickSearch(e),
    onFocus: () => {
      setShowbuttons(true);
    },
    onBlur: () => setShowbuttons(false)
  }, skipToSearch))))));
};
const SkipContentButtonsStyles = "sondeyl";
const SkipContentButtonsStylesRtl = "s1sygn9v";
export default SkipContentButtons;